// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hBrRt","actions":"styles_actions__lANSu","actions_btn":"styles_actions_btn__tzfId"};